export interface State {
  abbreviation: string;
  name: string;
}
